import React from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { Input } from "formsy-react-components";
import CurrencyInput from "../common/CurrencyInput";

const ProjectCalculatorForm = ({
  inputs,
  // showMonthlyHours,
  editing,
  onChange
}) => {
  const { budget_hours, budget_amount, rate } = inputs;

  // const isMonthlyHoursDisabled =
  //   (!editing && !inputs?.end_date && !inputs?.expected_end_date) ||
  //   (editing && !inputs?.end_date && !inputs?.expected_end_date);

  return (
    <React.Fragment>
      <Col md={3} xs={6}>
        <CurrencyInput
          required={editing}
          name="budget_amount"
          label="Budget Amount"
          onChange={(e) => onChange("budget_amount", e.target.value)}
          disabled={!editing}
          value={budget_amount}
        />
      </Col>
      <Col md={3} xs={6}>
        <CurrencyInput
          required={editing}
          name="rate"
          label="Billing Rate"
          onChange={(e) => onChange("rate", e.target.value)}
          disabled={!editing}
          value={rate}
        />
      </Col>
      <Col md={3} xs={6}>
        <Input
          required={editing}
          type="number"
          name="budget_hours"
          label="Budget Hrs"
          onChange={(field, value) => {
            onChange("budget_hours", value);
          }}
          disabled={!editing}
          value={budget_hours}
          step="0.01"
          pattern="[0-9]*"
        />
      </Col>
      {/* {showMonthlyHours ? (
        <Col md={3} xs={6}>
          <Input
            type="number"
            name="monthly_hours"
            label="Monthly Hrs"
            onChange={(field, value) => {
              onChange("monthly_hours", value);
            }}
            disabled={isMonthlyHoursDisabled}
            value={inputs?.monthly_hours}
            step="0.01"
            pattern="[0-9]*"
          />
        </Col>
      ) : null} */}
    </React.Fragment>
  );
};

ProjectCalculatorForm.propTypes = {
  inputs: PropTypes.object,
  editing: PropTypes.bool,
  // showMonthlyHours: PropTypes.bool,
  onChange: PropTypes.func
};

export default ProjectCalculatorForm;
